import { assets } from '../config/assetConfig';
//import icons

export default type => {
   switch(type){
      case 'png':
      return assets.fileIcon('png.png')
      case 'jpg':
      case 'jpeg':
      return assets.fileIcon('jpg.png')
      case 'doc':
      case 'docx':
      return assets.fileIcon('doc.png')
      case 'pdf':
      return assets.fileIcon('pdf.png')
      case 'ppt':
      case 'pptx':
      return assets.fileIcon('ppt.png')
      default:
      return assets.fileIcon('raw.png')
    }
}
